import script from "./CustomStepper.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomStepper.vue?vue&type=script&setup=true&lang=js"

import "./CustomStepper.vue?vue&type=style&index=0&id=315d11fb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-315d11fb"]])

export default __exports__